import React from "react";

import Typography from "@mui/material/Typography";

import Button from "components/Button";

import "./index.scss";

interface PageBannerProps {
  dataTestId?: string;
  overline?: string;
  title: string;
  subtitle?: string;
  img?: string;
  actionButtonText?: string;
  onActionsButtonClick?: () => void;
  variant?: "default" | "dark";
}

const SNOWFLAKE_COUNT = 50;

const PageBanner: React.FC<PageBannerProps> = (props) => {
  const {
    overline,
    title,
    subtitle,
    img,
    actionButtonText,
    onActionsButtonClick,
    variant = "default",
    dataTestId,
  } = props;

  return (
    <div
      className={`page-banner page-banner--${variant}`}
      data-testid={dataTestId}
    >
      {variant === "dark" && (
        <div className="snow">
          {Array.from({ length: SNOWFLAKE_COUNT }).map((_, i) => (
            <div key={i} className="snowflake" />
          ))}
        </div>
      )}

      <div className="page-banner-content-text">
        {overline && (
          <Typography variant="subtitle1" sx={{ mb: 2 }}>
            {overline}
          </Typography>
        )}
        <Typography sx={{ mb: 2 }} variant="h3">
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ mb: 3 }} variant="body1">
            {subtitle}
          </Typography>
        )}
        {onActionsButtonClick && actionButtonText && (
          <Button
            variant="contained"
            color="primary"
            onClick={onActionsButtonClick}
          >
            {actionButtonText}
          </Button>
        )}
      </div>
      {img && (
        <div className="page-banner-content-img">
          <img src={img} alt="banner" className="page-banner-img" />
        </div>
      )}
    </div>
  );
};

export default PageBanner;
